import { InviteMemberModalState } from '@adsk/acs-admin-ui-components-shared-components';

export const ACTIONS = {
  ...InviteMemberModalState.ACTIONS,
};
